/**
 * Xadrez de transparência (o padrão cinza/branco atrás de cores com alpha).
 *
 * Fica como constante e entra por `style`, não por classe utilitária: é uma data-URI de SVG com
 * aspas, espaços e parênteses, e o valor arbitrário do Tailwind exigiria escapar espaço por espaço
 * (`viewBox="0_0_2_2"`) em três lugares diferentes. Uma string nomeada é mais legível e não repete.
 */
export const CHECKERBOARD =
  'url(\'data:image/svg+xml;utf8, <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2 2"><path fill="white" d="M1,0H2V1H1V0ZM0,1H1V2H0V1Z"/><path fill="gray" d="M0,0H1V1H0V0ZM1,1H2V2H1V1Z"/></svg>\')';
